
$(".inview").on("inview", function (event, isInView) {
    if (isInView) {
        $(this).stop().addClass("is-show");
    }
});

/**
 * メイン動画
 */
var $reliabilitySection = $("#reliabilitySection");
var $mainVideo = $("#mainVideo").get(0);
var $mainSection = $("#mainSection");
$reliabilitySection.on("inview", function (event, isInView) {
    if (isInView) {
        if(!$mainVideo.paused) {
            $mainVideo.pause();
            $mainSection.css("visibility", "hidden");
        }
    }
});

var $campaignSection = $("#campaignSection");

$("#youtubeSection").on("inview", function (event, isInView) {
    if (isInView) {
        if($mainVideo.paused) {
            $mainSection.css("visibility", "visible");
            $mainVideo.play();
        }

        // キャンペーンバナー
        if($campaignSection.hasClass("fix")) {
            $campaignSection.removeClass("fix");
        }
    }
});

/**
 * 背景動画
 */
$(".bg-movie").on("inview", function (event, isInView) {
    if (isInView) {
        $(this).get(0).play();
    }
});

var $bgMovie1 = $("#bgMovie1").get(0);
$("#beginningSection").on("inview", function (event, isInView) {
    if (isInView) {
        if($bgMovie1.paused) {
            $bgMovie1.play();
        }
    }
});
$("#innovationSection").on("inview", function (event, isInView) {
    if (isInView) {
        if(!$bgMovie1.paused) {
            $bgMovie1.pause();
        }
    }
});

var $bgMovie2 = $("#bgMovie2").get(0);
$("#evolutionSection").on("inview", function (event, isInView) {
    if (isInView) {
        if($bgMovie2.paused) {
            $bgMovie2.play();
        }
    }
});
$("#partnershipSection").on("inview", function (event, isInView) {
    if (isInView) {
        if(!$bgMovie2.paused) {
            $bgMovie2.pause();
        }
    }
});

var $bgMovie3 = $("#bgMovie3").get(0);
$("#explorationSection").on("inview", function (event, isInView) {
    if (isInView) {
        if($bgMovie3.paused) {
            $bgMovie3.play();
        }
    }
});
$("#obsessiveDesignSection").on("inview", function (event, isInView) {
    if (isInView) {
        if(!$bgMovie3.paused) {
            $bgMovie3.pause();
        }
    }
});

// キャンペーンバナー
$reliabilitySection.on("inview", function (event, isInView) {
    if (isInView) {
        if(!$campaignSection.hasClass("fix")) {
            $campaignSection.addClass("fix");
        }
    }
});